import { SalesOrderModal } from './sales-order-modal';

export class SOMailModel {
  soDTO: SalesOrderModal;
  from: string;
  cc: string;
  bcc: string;
  to: string;
  subject: string;
  footer: string;
  message: string;
}
